


import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const redeemQuoteApi = createAsyncThunk("redeemQuote", async ({ startDate = null, endDate = null }) => {
  const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
  const response = await axiosInstance.get("/redeemQuote",{ params });
  return response.data;
});

const redeemQuoteSlice = createSlice({
  name: "redeemQuote",
  initialState: {
    redeemQuote: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(redeemQuoteApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(redeemQuoteApi.fulfilled, (state, action) => {
        state.redeemQuote = action.payload;
        state.loading = false;
      })
      .addCase(redeemQuoteApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default redeemQuoteSlice.reducer;


